import React from 'react'
import Link from 'next/link'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import clsx from 'clsx'
import Typo from 'constants/typography'
import styles from './style.scss'

const ContentLinks = (props) => {
  const { list, shop, lang, t, selectedLink } = props

  if (!list) return null

  return (
    <div className="side-container">
      <style jsx>{styles}</style>
      <span className={clsx('faq-title', Typo.subtitle2)}>{t('FAQ')}</span>
      <p className="line-separator">&nbsp;</p>
      <div className="listing-links">
        {list.map((listItem) => {
          const { title, link_rewrite } = listItem
          let hrefLink = `/faq?type=${link_rewrite}`
          let asLink = `/${shop}/${lang}/info/${link_rewrite}`

          if (link_rewrite === 'stores') {
            hrefLink = '/offline'
            asLink = `/${shop}/${lang}/offline`
          }

          return (
            <Link key={title} href={hrefLink} as={asLink}>
              <a>
                <span
                  className={`link-item ${
                    link_rewrite === selectedLink
                      ? `link-item-selected ${Typo.subtitle2}`
                      : Typo.body2
                  }`}
                >
                  {t(title)}
                </span>
              </a>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

ContentLinks.propTypes = {
  lang: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.shape({})),
  shop: PropTypes.string,
  t: PropTypes.func.isRequired,
  selectedLink: PropTypes.string,
}

ContentLinks.defaultProps = {
  selectedLink: undefined,
  lang: undefined,
  list: undefined,
  shop: undefined,
}

const Extended = translate('global')(ContentLinks)

export { ContentLinks }

export default Extended
